module.exports = __webpack_public_path__ + "static/media/home-desktop-1920.1c0706d8.jpg";